// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__b7u7Q","label":"CategoryService_label__3rFKM","location":"CategoryService_location__1htKU"};